import { Controller } from "@hotwired/stimulus"

// Pointer-following ghost cursor + item targets crossfading on a timer while hovered.
export default class extends Controller<HTMLElement> {
  static targets = ["ghost", "item"]
  static values = { speed: { type: Number, default: 3000 } }

  declare readonly hasGhostTarget: boolean
  declare readonly ghostTarget: HTMLElement
  declare readonly itemTargets: HTMLElement[]
  declare readonly speedValue: number

  index = 0
  timer?: number

  disconnect() {
    window.clearInterval(this.timer)
  }

  follow(event: MouseEvent) {
    if (!this.hasGhostTarget) return

    const rect = this.element.getBoundingClientRect()
    this.ghostTarget.style.left = `${event.clientX - rect.left}px`
    this.ghostTarget.style.top = `${event.clientY - rect.top}px`
  }

  start() {
    // Tailwind's hover: variants are gated by (hover: hover); a tap still fires
    // mouseenter, so without this guard the fact would overlay the description.
    if (!window.matchMedia("(hover: hover)").matches) return
    if (this.itemTargets.length === 0) return

    this.show(0)
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return
    this.timer = window.setInterval(() => this.show(this.index + 1), this.speedValue)
  }

  stop() {
    window.clearInterval(this.timer)
    this.itemTargets.forEach((item) => {
      item.classList.remove("opacity-100")
      item.classList.add("opacity-0")
    })
  }

  private show(index: number) {
    this.index = (index + this.itemTargets.length) % this.itemTargets.length
    this.itemTargets.forEach((item, i) => {
      item.classList.toggle("opacity-100", i === this.index)
      item.classList.toggle("opacity-0", i !== this.index)
    })
  }
}
